// extracted by mini-css-extract-plugin
export var chip = "_ec-0";
export var filterDropdown = "_ec-5";
export var filterItem = "_ec-6";
export var icon = "_ec-1";
export var removeButton = "_ec-3";
export var removeIcon = "_ec-4";
export var separator = "_ec-2";